import { cn } from "@/shared/lib/utils";
import { Skeleton } from "@/shared/components/ui/skeleton";

interface EnterpriseSectionSkeletonProps {
    rows?: number;
    showHeader?: boolean;
    className?: string;
    rowClassName?: string;
}

export function EnterpriseSectionSkeleton({
    rows = 4,
    showHeader = true,
    className,
    rowClassName,
}: EnterpriseSectionSkeletonProps) {
    return (
        <div className={cn("space-y-3", className)}>
            {showHeader ? <Skeleton className="h-5 w-44" /> : null}
            {Array.from({ length: rows }).map((_, index) => (
                <Skeleton
                    key={`row-${index}`}
                    className={cn("h-14 w-full rounded-lg", rowClassName)}
                />
            ))}
        </div>
    );
}
